import React from 'react';
import './Invitesent.css';
import envelop from '../../assets/envelop.png';
import { useNavigate } from 'react-router-dom';

const Invitesent = ({setShowOption, setOption}) => {
  const navigate = useNavigate();

  const handleOkay = () => {
    navigate('/singleemployee');
  };

  return (
    <div className="container-invitesent">

            {/* <div>
                <h2 className="sent-text">Invite sent successfully</h2>
            </div>
            <div>
                <p className="description">Email invite has been sent to employees.</p>
            </div>

            <button className="okay-button" onClick={handleOkay}>
            Okay
            </button> */}


        <div className="invite-body">
          <div className='envelop-icon mr-3'><img src={envelop} alt="envelop-icon" /></div>
          <div>
              <h2 className="sent-text">Invite sent successfully</h2>
          </div>
          <div>
              <p className="description">Email invite has been sent to employees.</p>
          </div>

          <button className="okay-button" onClick={() => (setShowOption(false), setOption('option1'))}>
            Okay
          </button>
        </div>
    </div>
  );
};

export default Invitesent;